<div class="generales">
<div fxLayout="column" fxLayoutAlign="center center" >
  <h1 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}" class="titulo">
    Correlations
  </h1>
  <video class="video" src="" controlslist="nodownload" controls></video>

  <h2><p>
    <strong>Objetivo</strong> <br>
    Conocer las herramientas de la plataforma tecnológica de reportes,
    en especifico, las  funciones  que  pueden  utilizarse  en  la  sección
    "Dimension  Discovery"  para conocer  el  nivel  de  confianza  según  las
    dimensiones,  competencias,  sub- competencias y reactivos del
    Great Place to Work Model®.
  </p></h2>

  </div>
  </div>
